import React from 'react';
import { Check } from 'lucide-react';
export function InterventionSection() {
  return <section className="bg-dark py-28 md:py-32 px-4" data-id="element-103">
      <div className="max-w-[1100px] mx-auto" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-textLight mb-8" data-id="element-106">
            Esto no es una clase. Es una intervención.
          </h2>

          <div className="text-lg md:text-xl text-textLight space-y-4 max-w-3xl mx-auto leading-relaxed" data-id="element-107">
            <p data-id="element-108">
              No vienes a aprender más. Vienes a tomar decisiones que cambian
              cómo opera tu negocio.
            </p>
            <p data-id="element-109">En esta sesión vas a ver con claridad:</p>
          </div>
        </div>

        <div className="flex flex-col items-start text-left gap-6 w-full max-w-2xl mx-auto mb-24" data-id="element-110">
          <div className="flex items-start gap-4" data-id="element-111">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-112" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-113">
              Qué eliminar — lo que solo te mantiene ocupada.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-114">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-115" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-116">
              Qué sostener — lo que sí está funcionando y hay que blindar.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-117">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-118" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-119">
              Qué priorizar — lo que va a mover tu negocio de verdad.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-120">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-121" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-122">
              Dónde está tu verdadero 20% — y cómo organizarte alrededor de él.
            </span>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-[#111111] border border-gray-800 rounded-2xl p-8 md:p-12" data-id="element-123">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-textLight mb-10 text-center" data-id="element-124">
            Cómo trabajamos los 90 minutos:
          </h3>

          <div className="space-y-8" data-id="element-125">
            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-126">
              <div className="text-accent font-bold text-lg md:text-xl shrink-0 md:w-48" data-id="element-127">
                Minutos 0–25
              </div>
              <div className="text-lg md:text-xl text-textLight" data-id="element-128">
                <span className="font-bold" data-id="element-129">Diagnóstico</span> — mapeas tus
                fugas reales, no las que crees que tienes.
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-130">
              <div className="text-accent font-bold text-lg md:text-xl shrink-0 md:w-48" data-id="element-131">
                Minutos 25–60
              </div>
              <div className="text-lg md:text-xl text-textLight" data-id="element-132">
                <span className="font-bold" data-id="element-133">Eliminación</span> — decides qué
                sale de tu semana esta semana.
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-134">
              <div className="text-accent font-bold text-lg md:text-xl shrink-0 md:w-48" data-id="element-135">
                Minutos 60–85
              </div>
              <div className="text-lg md:text-xl text-textLight" data-id="element-136">
                <span className="font-bold" data-id="element-137">Diseño</span> — defines tu 20%
                medular y cómo organizarte alrededor.
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-138">
              <div className="text-accent font-bold text-lg md:text-xl shrink-0 md:w-48" data-id="element-139">
                Minutos 85–90
              </div>
              <div className="text-lg md:text-xl text-textLight" data-id="element-140">
                <span className="font-bold" data-id="element-141">Compromiso</span> — sales con un
                ajuste concreto, no con una lista de buenas intenciones.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}